import structure from "../utils/structure";
import { createSlice } from "@reduxjs/toolkit";

export const roomSlice = createSlice({
    name: "data",
    initialState: {
        model: structure[0].elements[5],
        roof: structure[1].elements[0],
        exterior: structure[2].elements[1],
        interior: structure[3].elements[0],
        extras: [],
        visibleRoof: true,
        extAccent : "Madera Roble Vintage",
        intAccent : "Ninguno",
        apiData : {}
    },
    reducers: {
        setModel: (state, value) => {
            state.model = value.payload;
        },
        setRoof: (state, value) => {
            state.roof = value.payload;
        },
        setExterior: (state, value) => {
            state.exterior = value.payload;
        },
        setInterior: (state, value) => {
            state.interior = value.payload;
        },
        setExtras: (state, value) => {
            state.extras = value.payload;
        },
        setVisibleRoof: (state) => {
            state.visibleRoof = !state.visibleRoof;
        },
        showRoof: (state) => {
            state.visibleRoof = true;
        },
        hideRoof: (state) => {
            state.visibleRoof = false;
        },
        setExtAccent: (state, value) => {
            state.extAccent = value.payload;
        },
        setIntAccent: (state, value) => {
            state.intAccent = value.payload;
        },
        setApiData: (state, value) => {
            state.apiData = value.payload;
        }
    },
});

export const { setModel, setRoof, setExterior, setInterior, setExtras, setVisibleRoof, showRoof, hideRoof, setExtAccent, setIntAccent, setApiData } = roomSlice.actions;
export default roomSlice.reducer;
